import { ofType } from 'src/core/engine/rxjs/ofType';
import { Observable } from 'rxjs';
import { Actions } from 'src/core/state/user';
import { Deps } from 'src/types/global-types';
import { map } from 'rxjs';

/**
 * Listen for the user signing out - when they do so on any page
 * under /customisation then we just throw them back to the homepage
 *
 * @param action$
 * @param _state$
 * @param deps
 */
export function userSignOutReaction(action$: Observable<any>, _state$: Observable<any>, deps: Deps) {
    return action$.pipe(
        ofType<Actions>('User.SignOut'),
        map(() => deps.push('/')),
    );
}
